import { useState } from "react";
import { updateStudent } from "../../actions/teacherActions";
import {
  GetTeacherInformation,
  GetSchoolDataBySchoolId,
  GetStudentInfoByStudentId,
} from "../../actions/teacherQueries";
import { CCard, CRow, CCol, CCardBody } from "@coreui/react";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import TeacherAdmin from "../../components/Teacher/Tabs/TeacherAdmin";
import TeacherResultOverview from "../../components/Teacher/Tabs/TeacherResultOverview";
import TeacherDocuments from "../../components/Teacher/Tabs/TeacherDocuments";
import TeacherCourses from "../../components/Teacher/Tabs/TeacherCourses";
import TeacherChat from "../../components/Teacher/Tabs/TeacherChat";
import TabNavSelector from "../../components/Teacher/Tabs/TabNavSelector";
import APL from "../../components/APL/APL";
import { useSelector } from "react-redux";

function TeacherStudent(props) {
  const [toggleEditModal, setToggleEditModal] = useState(false);
  const [updated, setUpdated] = useState(false);
  const studentInfo = GetStudentInfoByStudentId(props.match.params.studentId);
  const teacherInfo = GetTeacherInformation();
  const schoolInfo = GetSchoolDataBySchoolId(
    !teacherInfo.isLoading ? teacherInfo.data.customer.id : null
  );

  const tab = useSelector((state) => state.teacherTabNavReducer);
  const editToggleEditModal = () => {
    setToggleEditModal(!toggleEditModal);
  };
  const updateStore = (student) => {
    props.dispatch(updateStudent(student));
    setUpdated(!updated);
  };

  if (teacherInfo.isLoading || studentInfo.isLoading) {
    return <Pacmanloader />;
  }

  let teacherClasses = [];

  teacherInfo.data.programmes.forEach((programme) => {
    programme.classes.forEach((clas) => {
      teacherClasses.push(clas);
    });
  });

  const renderTab = () => {
    switch (tab.tab) {
      case 1:
        return (
          <TeacherAdmin
            level="Student"
            studentId={props.match.params.studentId}
            key={studentInfo.data.id + " " + updated}
            student={studentInfo.data}
            studentHasLicense={studentInfo.data.licenses.length > 0}
            toggleEdit={editToggleEditModal}
            isOpen={toggleEditModal}
            updateStudents={updateStore}
            classes={teacherClasses}
            school={teacherInfo.data.customer}
            teacherInfo={teacherInfo}
            schoolInfo={schoolInfo}
          />
        );
      case 2:
        return (
          <TeacherCourses
            level="Student"
            objId={"student" + props.match.params.studentId}
            studentId={props.match.params.studentId}
            teacherInfo={teacherInfo}
            displayDocuments={false}
          />
        );
      case 3:
        return (
          <TeacherResultOverview
            level="Student"
            studentHasLicense={studentInfo.data.licenses.length > 0}
            studentId={props.match.params.studentId}
            student={studentInfo.data}
          />
        );
      case 5:
        return <TeacherDocuments level="Student" />;
      case 6:
        return <TeacherChat level="Class" />;
      case 7:
        return (
          <APL
            levelName={[studentInfo.data.name]}
            students={[studentInfo.data]}
            level={"Student"}
            objId={studentInfo.data.id}
            schoolId={teacherInfo.data.customer.id}
            programId={props.match.params.programId}
            teacherInfo={teacherInfo}
          />
        );
      default:
        return <TeacherAdmin level="Student" />;
    }
  };

  return (
    <div className="teacher-container animated fadeIn">
      <CRow>
        <CCol lg={12}>
          <CCard>
            <TabNavSelector level={"student"} objId={props.match.params.studentId} />
            <CCardBody className="responsive-card">{renderTab()}</CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
}

export default TeacherStudent;
